import axios, { AxiosPromise, AxiosRequestConfig, Method } from "axios"
import { MEDUSA_BACKEND_URL } from "../constants/medusa-backend-url"

const client = axios.create({ baseURL: MEDUSA_BACKEND_URL })

export default async function medusaRequest<T>(
  method: Method,
  path = "",
  payload = {}
) {
  const options: AxiosRequestConfig = {
    method,
    withCredentials: true,
    url: path,
    data: payload,
    headers: {},
  }
  return client(options) as AxiosPromise<T>
}
